import type { OptionProps } from '@/components/selects/Select'

export enum SUPPORTED_LANGUAGES {
  english = 'en',
  spanish = 'es',
}

const SUPPORTED_LANGUAGES_LABELS = {
  [SUPPORTED_LANGUAGES.english]: 'English',
  [SUPPORTED_LANGUAGES.spanish]: 'Spanish',
}

export const supportedLanguages: OptionProps[] = Object.entries(SUPPORTED_LANGUAGES_LABELS).map(
  ([value, label]) => ({
    value,
    label,
  }),
)
